module.exports = __webpack_public_path__ + "img/logo.9c50888b.png";